import React, { Component } from 'react';
import './UsefulLinks.css';
import BookLoader from './loaders/bookloader';

export default class UsefulLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [],
      loading: true, // Added loading state for better control
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/usefullinks/`)
      .then((response) => response.json())
      .then((data) => this.setState({ links: data, loading: false }))
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  }

  render() {
    const { links, loading } = this.state;

    if (loading) {
      return (
        <div className="loader-container">
          <BookLoader
            background={"linear-gradient(135deg, #6066FA, #fa6616)"}
            desktopSize={"100px"}
            mobileSize={"80px"}
            textColor={"#fa6616"}
          />
        </div>
      );
    }

    return (
      <section className="useful-links-section">
        <div className="container">
          
          {/* Header Section */}
          <div className="section-header text-center mb-5">
            <h5 className="sub-title">Resources</h5>
            <h2 className="title">Useful Links & References</h2>
            <div className="header-line"></div>
          </div>

          <div className="row">
            {links.length > 0 ? (
              links.map((link, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <a href={link.link} target="_blank" rel="noopener noreferrer" className="card-link-wrapper">
                    <div className="resource-card h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-start">
                          {/* Icon / Image */}
                          <div className="icon-wrapper">
                            <img 
                              src={link.img || "https://via.placeholder.com/50"} 
                              alt={link.title} 
                              className="resource-icon" 
                              onError={(e) => {e.target.src = 'https://via.placeholder.com/50'}} // Fallback image
                            />
                          </div>
                          
                          {/* Content */}
                          <div className="content-wrapper ms-3">
                            <h5 className="resource-title">
                              {link.title}
                              <span className="external-icon">↗</span>
                            </h5>
                            <p className="resource-desc">
                              {link.discrption}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <div className="empty-state">
                  <p>No useful links available at the moment.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}